// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"d39da075","404":"19f02efa"}[chunkId] + ".chunk.js";
};